/** ----------------------------------------
    Node Modules
 ---------------------------------------- */

import anime from 'animejs';

/** ----------------------------------------
    Helpers
 ---------------------------------------- */

import * as dom from '@util/dom';

/* ----------------------------------------
    Modules
---------------------------------------- */

import { Overlay } from '@js/module/Overlay';
const overlay = new Overlay(1000);

/** ----------------------------------------
     Create Overlay
 ---------------------------------------- */

const createLayer = (color, name = 'layer') => {
    const el = document.createElement('div');

    dom.style(el, {
        width: '100%',
        height: 0,
        background: color,
        position: 'fixed',
        bottom: 0,
        left: 0,
        zIndex: 100000
    });

    dom.attr(el, {
        class: name
    });

    document.body.insertAdjacentHTML('beforeend', el.outerHTML);

    return document.querySelector('.' + name);
};

/** ----------------------------------------
     Animation
 ---------------------------------------- */

const animationIn = (el, delay = 0) => {
    overlay.createOverlay();

    return new Promise((resolve) => {
        anime({
            targets: el,
            height: '100%',
            duration: 1000,
            delay: delay,
            easing: 'easeInQuart',
            complete: () => resolve(el)
        });
    });
};

const animationOut = el => {
    dom.style(el, {
       bottom: 'auto',
       top: 0
    });

    return new Promise((resolve) => {
        anime({
            targets: el,
            height: 0,
            duration: 750,
            delay: 750,
            easing: 'easeOutQuart',
            begin: () => resolve(el),
            complete: () => {
                overlay.removeOverlay();

                const layersProject = document.querySelectorAll('.layer--project');
                const layersDefault = document.querySelectorAll('.layer--default');

                setTimeout(() => {
                    layersProject && [...layersProject].forEach(layer => layer.remove());
                    layersDefault && [...layersDefault].forEach(layer => layer.remove());
                }, 250);
            }
        });
    });
};

/** ----------------------------------------
     Reveal
 ---------------------------------------- */

const revealContent = el => {
    anime({
        targets: el,
        opacity: [0, 1],
        marginTop: [175, 0],
        delay: 600,
        duration: 450,
        easing: 'easeOutQuad',
    });
};

/** ----------------------------------------
     Switch Case
 ---------------------------------------- */

const switchCase = (el, color) => {
    return new Promise(resolve => {
        const firstLayer = createLayer('#FFFFFF', 'layer--default');

        animationIn(firstLayer)
            .then(layer => animationOut(layer));

        const secondLayer = createLayer(color, 'layer--project');

        animationIn(secondLayer, 250)
            .then(layer => animationOut(layer).then(() => resolve()));
    });
};

/** ----------------------------------------
    Switch Page
 ---------------------------------------- */

const switchPage = el => {
    return new Promise(resolve => {
        const firstLayer = createLayer('#FFFFFF', 'layer--default');

        animationIn(firstLayer)
            .then(layer => animationOut(layer).then(() => resolve()));
    });
};

/** ----------------------------------------
    Exports
 ---------------------------------------- */

export {
    switchCase,
    switchPage
};